<template>
    <div style="text-align: center">
        <!-- <el-checkbox class="checkbox-sty" v-model="checked" @change="changeFn">纯英文识别</el-checkbox> -->
        <el-upload style="width: 100%" ref="uploadOrigin" class="upload-demo" drag multiple :with-credentials="true"
            :auto-upload="true" :action="uploadURL" :data="uploadParams" :headers="uploadHeaders"
            :on-success="uploadSuccess" :limit="10" :on-exceed="uploadExceed" :before-upload="beforeUpload"
            :on-progress="uploadProgress" :on-error="uploadError" :on-remove="uploadRemove" :on-change="uploadChange"
            accept=".doc,.DOC,.docx,.DOCX,.xls,.XLS,.xlsx,.XLSX,.zip,.rar,.jpeg,.jpg,.png,.tif,.pdf,.PDF,.7z">
            <div class="upload" @click="resetUpload">
                <div class="dragnone">
                    <div class="box">
                        <div class="circle">
                            <!-- <i class="icon icon-upload"></i> -->
                        </div>
                        <div class="text"><em>本地上传</em>或拖放文件到这里</div>
                    </div>
                    <span class="tips">支持文件格式：.doc .docx .xls .xlsx .zip .rar .7z .jpeg .jpg .png .tif
                        .pdf（不支持压缩包套压缩包格式），每次最多上传10份文件，每份文件需小于等于60M</span>
                </div>
            </div>
        </el-upload>
    </div>
</template>
<script>
    import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'

    export default {
        name: 'uploadFile',
        props: {},
        data() {
            return {
                uploadURL: this.$upload.url,
                uploadParams: {},
                uploadHeaders: {},
                fileList: [],
                checked: false
            }
        },
        components: {},
        watch: {
            $route(to, from) {
                if (to.path.includes('endoc')) {
                    this.uploadParams.type = 1
                } else {
                    this.uploadParams.type = 3
                }
            }
        },
        mounted() {
            if (this.$route.path.includes('endoc') === true) {
                this.uploadParams.type = 1
            } else {
                this.uploadParams.type = 3
            }

            // 依赖DashIndex.vue 中设置localStorage'BAILIAN-SHIBIE-OFFICEWEBSITE-TOKEN'
            setTimeout(() => {
                // 先获取官网token，在赋值
                this.uploadHeaders = this.$header()
            }, 500)

            //上传文件拖拽dom
            let dragger = document.querySelector('.el-upload-dragger')
            dragger.ondragover = e => {
                //拖拽事件，清除上一次上传文件记录
                this.resetUpload()
            }
        },
        methods: {
            setFileName(str, name) {
                if (!str.includes('.')) {
                    return name
                }
                if (
                    str.includes('.') &&
                    name.indexOf('.') !== name.lastIndexOf('.')
                ) {
                    let newName =
                        str.replace('.', '') +
                        '.' +
                        name.substr(name.lastIndexOf('.') + 1)
                    let newStr = newName.substr(0, newName.lastIndexOf('.'))

                    return this.setFileName(newStr, newName)
                }
            },
            beforeUpload(file) {
                //判断登录超时,再次上传文件时，需要调回至登录页面重新进行登录
                let type = file.type.toUpperCase()
                let name = file.name
                let nameUpper = file.name.toUpperCase()
                let nameType = nameUpper.substr(nameUpper.lastIndexOf('.') + 1)

                // 处理文件名中包含多个小数点，递归转换成空字符串
                let str = name.substr(0, name.lastIndexOf('.'))
                name = this.setFileName(str, name)

                let fileType
                let isList
                if (type === 'APPLICATION/X-ZIP-COMPRESSED') {
                    fileType = 'zip'
                } else if (type === 'APPLICATION/ZIP') {
                    fileType = 'zip'
                } else if (type === 'APPLICATION/X-RAR') {
                    fileType = 'rar'
                } else if (nameType === 'RAR') {
                    fileType = 'rar'
                } else if (type === 'APPLICATION/PDF') {
                    fileType = 'pdf'
                } else if (type === 'IMAGE/JPEG') {
                    fileType = 'jpeg'
                } else if (type === 'IMAGE/JPG') {
                    fileType = 'jpg'
                } else if (type === 'IMAGE/PNG') {
                    fileType = 'png'
                } else if (type === 'IMAGE/TIFF') {
                    fileType = 'tif'
                } else if (
                    type ===
                    'APPLICATION/VND.OPENXMLFORMATS-OFFICEDOCUMENT.WORDPROCESSINGML.DOCUMENT'
                ) {
                    fileType = 'docx'
                } else if (
                    type ===
                    'APPLICATION/VND.OPENXMLFORMATS-OFFICEDOCUMENT.SPREADSHEETML.SHEET'
                ) {
                    fileType = 'xlsx'
                } else if (type === 'APPLICATION/MSWORD') {
                    fileType = 'doc'
                } else if (nameType === 'XLS') {
                    fileType = 'xls'
                } else if (nameType === 'XLSX') {
                    fileType = 'xlsx'
                } else if (nameType === 'DOC') {
                    fileType = 'doc'
                } else if (nameType === 'DOCX') {
                    fileType = 'docx'
                } else if (nameType === '7Z') {
                    fileType = '7z'
                }

                //兼容windows，zip,rar文件
                isList =
                    type === 'APPLICATION/ZIP' ||
                    type === 'APPLICATION/X-ZIP-COMPRESSED' ||
                    type === 'APPLICATION/X-RAR' ||
                    nameType === 'RAR' ||
                    type === 'IMAGE/JPEG' ||
                    type === 'IMAGE/JPG' ||
                    type === 'IMAGE/PNG' ||
                    type === 'APPLICATION/PDF' ||
                    type === 'IMAGE/TIFF' ||
                    type ===
                    'APPLICATION/VND.OPENXMLFORMATS-OFFICEDOCUMENT.WORDPROCESSINGML.DOCUMENT' ||
                    type ===
                    'APPLICATION/VND.OPENXMLFORMATS-OFFICEDOCUMENT.SPREADSHEETML.SHEET' ||
                    nameType === 'XLS' ||
                    nameType === 'XLSX' ||
                    nameType === 'DOC' ||
                    type === 'APPLICATION/MSWORD' ||
                    nameType === 'DOCX' ||
                    nameType === '7Z'

                if (!isList) {
                    this.$message.error(
                        '上传支持文件格式：.doc .docx .xls .xlsx .zip .rar .7z .jpeg .jpg .png .tif .pdf!'
                    )
                    return false
                }

                //单个文件小于10M
                let size = file.size / 1024 / 1024
                const isLt2M = size < 100 && size !== 0

                if (size === 0) {
                    this.$message.error('不支持空文件上传')
                    return false
                }
                if (!isLt2M) {
                    this.$message.error('上传失败，' + file.name + ' 大小超出100M')
                    return false
                }

                if (isList && isLt2M) {
                    this.insertHeadTable(name, fileType, size, file)
                }

                return isList && isLt2M
            },
            insertHeadTable(name, fileType, size, file) {
                let time = new Date(file.uid).toTimeString().split(' ')[0]
                let date = new Date(file.uid).toISOString().split('T')[0]
                let id = Math.floor(Math.random() * 300)

                let newSize = file.size / 1024 //以kb为单位
                // 往表格里头部插入一条假进度条,临时temp_id
                this.$parent.tableData.unshift({
                    tempFile: true, //新增属性
                    category: '-',
                    format: fileType,
                    seqNo: id,
                    id: id,
                    temp_id: id,
                    recognitionCount: {},
                    resName: name,
                    size: newSize,
                    sizeWithUnit: newSize.toFixed(2) + 'K',
                    status: '排队上传中...',
                    uploadTime: date + ' ' + time,
                    uploadUser: '',
                    uploadTrip: 0,
                    uploadCo: 0,
                    checkFlag: '0_--',
                    hasChildren: false
                })

                //根据上传文件的大小，设定假的进度条间隔时间
                let upload_size = size //k
                let upload_time = 10
                if (upload_size <= 2048) {
                    upload_time = 1000
                } else if (upload_size > 2048 && upload_size <= 10240) {
                    upload_time = 2000
                } else {
                    upload_time = 3000
                }

                this.$nextTick(() => {
                    // console.log(document.querySelector("#uploadTemp_" + id), id)
                    //临时进度数字增长到99,
                    if (document.querySelector('#uploadTemp_' + id)) {
                        progressJs('#uploadTemp_' + id)
                            .setOptions({ overlayMode: false })
                            .start()
                            .autoIncreaseStop(4, upload_time, 99)
                    }
                })
            },
            uploadSuccess(response, file, fileList) {
                // this.$message.success('上传成功');
                let data = response.data
                let list = data[0]
                if (data.msg) {
                    this.$parent.tableData.splice(0, 1)

                    this.$message.info(data.msg)
                    return
                }
                if (data) {
                    let ar = []
                    let c = []
                    if (list) {
                        // 用名字匹配假数据
                        this.$parent.tableData.forEach((x, index) => {
                            if (
                                x.resName.toLowerCase() ===
                                list.resName.toLowerCase()
                            ) {
                                ar.push(index)
                                c.push(x)
                            }
                        })

                        //保存temp_id,并且结束进度条100
                        let temp_id = c[0].temp_id
                        progressJs('#uploadTemp_' + temp_id)
                            .set(100)
                            .end()

                        // 表格树形不展开
                        list.hasChildren = false

                        //替换掉临时上传假数据
                        this.$parent.tableData.splice(ar[0], 1, list)

                        //上传成功一条数据，删除掉本页最后一条数据
                        if (this.$parent.tableData.length >= 10) {
                            this.$parent.tableData.pop()
                        }

                        this.$parent.total += 1
                    }
                    this.$parent.currentPage = this.localPage

                    if (data.length > 0) {
                        data.forEach(item => {
                            //新增属性
                            item.random = 0

                            // 用id连接websocket
                            this.$parent.getWebsocket(item.id)
                        })
                    }
                }
            },
            uploadChange(file, fileList) {
                this.fileList = fileList
            },
            resetUpload() {
                this.$refs.uploadOrigin.clearFiles()
            },
            uploadProgress(event, file, fileList) { },
            uploadError() {
                this.$router.push({
                    name: 'login'
                })
            },
            uploadExceed(x) {
                this.$message.error('上传文件份数需要小于等于10份')
            },
            uploadRemove() { },
            changeFn(v) {
                if (v) {
                    this.uploadParams.type = 1
                }
            }
        }
    }
</script>
<style>
    .checkbox-sty {
        margin-bottom: 10px;

        .el-checkbox__label {
            font-size: 16px !important;
            font-weight: 600 !important;
            /* color: red; */
        }
    }

    .upload-demo {
        text-align: center;
        /*padding-top: 28px;*/

        .dragover {
            position: absolute;
            top: 0;
            left: 0;
            display: none;
        }

        .dragnone {
            display: block;
        }

        .el-upload-list {
            display: none;
        }

        .el-upload-dragger.is-dragover {
            .dragnone {
                opacity: 0.2;
            }

            .el-icon-plus,
            .el-upload__text,
            .close {
                display: block;
            }
        }

        .el-icon-plus {
            position: absolute;
            top: 8px;
            left: 211px;
            font-size: 28px;
            color: #aeaeae;
            margin-top: 24px;
            display: none;
        }

        .el-upload__text {
            position: absolute;
            top: 49px;
            left: 211px;
            color: #c4c5c6;
            margin-top: 18px;
        }

        .close {
            position: absolute;
            top: 10px;
            right: 10px;
            color: #b1b1b2;
            display: none;
        }

        .el-upload {
            width: 100%;
        }
    }
</style>